export const CROP_TYPES = {
  ARROZ: "ARROZ",
  CAFE: "CAFE",
  MILHO: "MILHO",
  SOJA: "SOJA",
  CANA: "CANA",
  ALGODAO: "ALGODAO",
  FLORESTA: "FLORESTA",
  PASTO: "PASTO",
  FRUTICULTURA: "FRUTICULTURA",
  HORTICULTURA: "HORTICULTURA",
  OUTROS: "OUTROS",
}

export const CROP_TYPES_NAMES = {
  [CROP_TYPES.ARROZ]: "Arroz",
  [CROP_TYPES.CAFE]: "Café",
  [CROP_TYPES.MILHO]: "Milho",
  [CROP_TYPES.SOJA]: "Soja",
  [CROP_TYPES.CANA]: "Cana",
  [CROP_TYPES.ALGODAO]: "Algodão",
  [CROP_TYPES.FLORESTA]: "Silvicultura",
  [CROP_TYPES.PASTO]: "Pasto",
  [CROP_TYPES.FRUTICULTURA]: "Fruticultura",
  [CROP_TYPES.HORTICULTURA]: "Horticultura",
  [CROP_TYPES.OUTROS]: "Outros",
}

export const CROP_TYPES_FILTER_LIST = [
  // {
  //   text: "Arroz",
  //   value: CROP_TYPES.ARROZ,
  // },
  // {
  //   text: "Café",
  //   value: CROP_TYPES.CAFE,
  // },
  {
    text: "Milho",
    value: CROP_TYPES.MILHO,
  },
  {
    text: "Soja",
    value: CROP_TYPES.SOJA,
  },
  {
    text: "Cana",
    value: CROP_TYPES.CANA,
  },
  {
    text: "Algodão",
    value: CROP_TYPES.ALGODAO,
  },
  {
    text: "Silvicultura",
    value: CROP_TYPES.FLORESTA,
  },
  // {
  //   text: "Pasto",
  //   value: CROP_TYPES.PASTO,
  // },
  // {
  //   text: "Fruticultura",
  //   value: CROP_TYPES.FRUTICULTURA,
  // },
  // {
  //   text: "Horticultura",
  //   value: CROP_TYPES.HORTICULTURA,
  // },
  {
    text: "Outros",
    value: CROP_TYPES.OUTROS,
  },
]

export const AREA_UNIT_TYPES = {
  HECTARE: "ha",
  SQUARE_CENTIMETERS: "cm2",
  SQUARE_METERS: "m2",
  SQUARE_KILOMETERS: "km2",
}

export const AREA_UNIT_TYPES_LIST = [
  {
    text: AREA_UNIT_TYPES.HECTARE,
    value: AREA_UNIT_TYPES.HECTARE,
  },
  {
    text: AREA_UNIT_TYPES.SQUARE_CENTIMETERS,
    value: AREA_UNIT_TYPES.SQUARE_CENTIMETERS,
  },
  {
    text: AREA_UNIT_TYPES.SQUARE_METERS,
    value: AREA_UNIT_TYPES.SQUARE_METERS,
  },
  {
    text: AREA_UNIT_TYPES.SQUARE_KILOMETERS,
    value: AREA_UNIT_TYPES.SQUARE_KILOMETERS,
  },
]
